<div class="box">
    <div class="box-header">
        <h3 class="box-title"> Pump Location </h3>
    </div>

    <div class="box-body">

        <agm-map [latitude]="lat" [longitude]="lng">

            <agm-marker
                *ngFor="let marker of pumps"
                [latitude]="marker.Lat"
                [longitude]="marker.Lng">
                <agm-info-window>
                   <p> {{marker.PumpName}}</p>
                   <p></p>{{ marker.Location }}
                   <span *ngIf="GetStatus(marker.Status)" class="label label-success">Active</span>
                    <span *ngIf="!GetStatus(marker.Status)" class="label label-inactive">Incitive</span>
                </agm-info-window>
            </agm-marker>

        </agm-map>
    </div>

</div>
